import { createContext, useContext, useState } from 'react';

interface IChatContext {
  showMessaging: boolean;
  updateShowMessaging: (nextShowMessaging: boolean) => void;
}

const ChatContext = createContext<IChatContext>({
  showMessaging: false,
  updateShowMessaging: () => {},
});

export const ChatProvider: React.FC = ({ children }) => {
  const [showMessaging, setShowMessaging] = useState(false);

  return (
    <ChatContext.Provider
      value={{
        showMessaging,
        updateShowMessaging: setShowMessaging,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export function useChatContext() {
  return useContext(ChatContext);
}
